export default __webpack_public_path__ + "static/media/4Pack_combinado.fd7e212c.png";